import type { ScanCodeResponse } from '@/infrastructure/FulfillmentAdminClient';

/**
 * The single switch for reading an order's own outbound waybill as a customer return [SSD-7409].
 * Every order is carrier-booked at creation and the desk can print that label before inbound, so a scan of
 * it is usually the order going out, not a parcel coming back. Off for now: the scan opens the order the way
 * its order number does, and a real return is handled from Order Detail. Set it back to true to restore
 * return mode on the scan once a rule for telling the two apart is agreed.
 */
export const scanReading: { outboundWaybillOpensReturnMode: boolean } = {
  outboundWaybillOpensReturnMode: false,
};

/** The dispatcher's reading as the desk screens act on it: an outbound waybill opens its order while the switch is off. */
export const readScanCode = (response: ScanCodeResponse): ScanCodeResponse =>
  response.kind === 'RETURN_WAYBILL' && response.orderId != null && !scanReading.outboundWaybillOpensReturnMode
    ? { ...response, kind: 'ORDER_WAYBILL' }
    : response;
